/* eslint quotes:0 */
const DEFAULT_MIN = 1;
const DEFAULT_MAX = 80000;

const weightLimits = {
  '09 LEASE Vehicle, Automobile, (under 9 passenger)': {
    min: DEFAULT_MIN,
    max: DEFAULT_MAX,
  },
  'Automobile, for HIRE, SPECIAL ANY 6 Month period, (under 9 passenger)': {
    min: DEFAULT_MIN,
    max: DEFAULT_MAX,
  },
  '54 Trailers, for HIRE thru 1999 lbs': {
    min: DEFAULT_MIN,
    max: 1999,
  },
  '54 Trailers, for HIRE 2000 lbs and over': {
    min: 2000,
    max: DEFAULT_MAX,
  },
  '53 Trailers Private Use over 500 lbs': {
    min: 501,
    max: DEFAULT_MAX,
  },
  '36 Bus, 9 passenger and over, all types except private school bus': {
    min: DEFAULT_MIN,
    max: DEFAULT_MAX,
  },
  '36 Bus, 9 passenger and over, all types except private school bus, 6 month semiannual': {
    min: DEFAULT_MIN,
    max: DEFAULT_MAX,
  },

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
  // TODO: All of these entries below need to be updated to reflect the
  // actual PIPE description `r0` (not the dropdown label), otherwise, we
  // can't use them to look anything up.
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

  /*
  '01 Automobile, Private Use, thru 2499 lbs': {
    min: 0,
    max: 2499,
  },
  "01 Automobile, Private Use, 2500 to 3499 lbs": {
    min: 2500,
    max: 3499,
  },
  "01 Automobile, Private Use, over 3500 lbs": {
    min: 3500,
    max: Number.MAX_VALUE,
  },
  "14 Non-Resident Military, Automobile, Private Use": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "82 Horseless Carriage": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "95 Antique Passenger Cars (with Antique Plate)": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "14 Non-Resident Military, Truck / Pickup thru 7999 lbs, Private Use": {
    min: 0,
    max: 7999,
  },
  "31 Truck / Pickup thru 1999 lbs": {
    min: 0,
    max: 1999,
  },
  "31 Truck / Pickup 2000 to 3000 lbs": {
    min: 2000,
    max: 3000,
  },
  "31 Truck / Pickup 3001 to 5000 lbs": {
    min: 3001,
    max: 5000,
  },
  "42 Chassis Mount Camper, unit affixed to truck chassis, thru 4499 lbs": {
    min: 0,
    max: 4499,
  },
  "42 Chassis Mount Camper, unit affixed to truck chassis, 4500 lbs and over": {
    min: 4500,
    max: Number.MAX_VALUE,
  },
  "42 Motor home thru 4499 lbs": {
    min: 0,
    max: 4499,
  },
  "42 Motor home, 4500 lbs and over": {
    min: 4500,
    max: Number.MAX_VALUE,
  },
  "42 Private Motor Coach, thru 4499 lbs": {
    min: 0,
    max: 4499,
  },
  "42 Private Motor Coach, 4500 lbs and over": {
    min: 4500,
    max: Number.MAX_VALUE,
  },
  "91 Antique Truck &lt; 5000 lbs net Weight / Military Trailer": {
    min: 0,
    max: 5000,
  },
  "65 Motorcycles": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "80 Motorcycles, Antique Plate": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "65 Motorized and Disability Access Vehicle": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "80 Motorized and Disability Access Vehicle, Antique Plate": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "69 Mopeds &lt; 2 BrakeHorsePower, pedal-activated motor": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "52 Trailers Private Use under 500 lbs": {
    min: 0,
    max: 500,
  },
  "56 Trailer (Semi-Trailer) drawn only by GVW Series truck tractors on 5th wheel, any weight": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "62 Camp trailers, constructed with folding walls": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "78 Travel Trailers over 35, License plate, not affixed to property": {
    min: 36,
    max: Number.MAX_VALUE,
  },
  "91 Antique Military Trailer": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "103 Permanent Semi-Trailer (drawn only by GVW Series truck tractors on 5th wheel, any weight)": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "70 Transporter Plate": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "71 Dealer Type Plates (VI, VF, MC, & Trailer Coach) +$27 Use Tax": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "74 Dealer Type Plates (Marine Boat Trailer) +$27 Use Tax": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "92 Hearses, & Ambulances": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "92 School Buses, exclusive transport pupils in home county (not _class 96)": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "94 TractorCranes, PowerShovels, Well Drillers, Tools with no hauling allowed": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "37 Exempt Disabled Veteran License Plate": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "85 Exempt Disabled Veteran Wheelchair License Plate": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "96 Boy Scouts, Churches, other specific non-profit": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "97 Exempt Government Vehicle License Plates": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "101 Vessel Dealer": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "Exempt Vessel,Girl Scout,Boy Scout,Government": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "Antique Vessel, at least 30 years old, Recreational Use only, with certification": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "41 Truck / Truck-Tractor 5001 to 5999 lbs GVW": {
    min: 5001,
    max: 5999,
  },
  "41 Truck / Truck-Tractor 8000 to 9999 lbs GVW": {
    min: 8000,
    max: 9999,
  },
  "41 Truck / Truck-Tractor 10,000 to 14,999 lbs GVW": {
    min: 10000,
    max: 14999,
  },
  "41 Truck / Truck-Tractor 15,000 to 19,999 lbs GVW": {
    min: 15000,
    max: 19999,
  },
  "41 Truck / Truck-Tractor 20,000 to 26,000 lbs GVW": {
    min: 20000,
    max: 26000,
  },
  "41 Truck / Truck-Tractor 26,001 to 34,999 lbs GVW": {
    min: 26001,
    max: 34999,
  },
  "41 Truck / Truck-Tractor 35,000 to 43,999 lbs GVW": {
    min: 35000,
    max: 43999,
  },
  "41 Truck / Truck-Tractor 44,000 to 54,999 lbs GVW": {
    min: 44000,
    max: 54999,
  },
  "41 Truck / Truck-Tractor 55,000 to 61,999 lbs GVW": {
    min: 55000,
    max: 61999,
  },
  "41 Truck / Truck-Tractor 62,000 to 71,999 lbs GVW": {
    min: 62000,
    max: 71999,
  },
  "102 Agricultural Truck/Truck-Tractor under 10,000 lbs GVW": {
    min: 0,
    max: 9999,
  },
  "102 Agricultural Truck/Truck-Tractor 10,000b thru 43,999 lbs GVW": {
    min: 10000,
    max: 43999,
  },
  "41 Truck / Truck-Tractor 72,000 to 80,000 lbs GVW": {
    min: 72000,
    max: 80000,
  },
  "102 Agricultural Truck/Truck-Tractor 44000 to 80,000 lbs GVW": {
    min: 44000,
    max: 80000,
  },
  "93 Agricultural vehicle, Goats, all": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "39 Forestry Truck/Truck-Tractor under 10,000 GVW": {
    min: 0,
    max: 9999,
  },
  "39 Forestry Truck/Truck-Tractor 10,000 and up GVW": {
    min: 10000,
    max: Number.MAX_VALUE,
  },
  "41 Wrecker, Unrestricted, 10,000 to 14,999 lbs GVW": {
    min: 10000,
    max: 14999,
  },
  "41 Wrecker, Unrestricted, 15,000 to 19,999 lbs GVW": {
    min: 15000,
    max: 19999,
  },
  "41 Wrecker, Unrestricted, 20,000 to 25,999 lbs GVW": {
    min: 20000,
    max: 25999,
  },
  "41 Wrecker, Unrestricted, 26,000 to 34,999 lbs GVW": {
    min: 26000,
    max: 34999,
  },
  "41 Wrecker, Unrestricted, 35,000 to 43,999 lbs GVW": {
    min: 35000,
    max: 43999,
  },
  "41 Wrecker, Unrestricted, 44,000 to 54,999 lbs GVW": {
    min: 44000,
    max: 54999,
  },
  "41 Wrecker, Unrestricted, 55,000 to 61,999 lbs GVW": {
    min: 55000,
    max: 61999,
  },
  "41 Wrecker, Unrestricted, 62,000 to 71,999 lbs GVW": {
    min: 62000,
    max: 71999,
  },
  "41 Wrecker, Unrestricted, 72,000 to 80,000 lbs GVW": {
    min: 72000,
    max: 80000,
  },
  "54 Trailers, for HIRE, 2000 lbs and over": {
    min: 2000,
    max: Number.MAX_VALUE,
  },
  "36 Buses, 9 passenger and over, (All except private school bus)": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "36 Buses, 9 passenger and over,(All except private school bus) 6 month semiannual": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  */
};

export default weightLimits;
